import script from "./BacktestPositionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BacktestPositionTable.vue?vue&type=script&setup=true&lang=js"

import "./BacktestPositionTable.vue?vue&type=style&index=0&id=4d41b1a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d41b1a4"]])

export default __exports__